export default __webpack_public_path__ + "static/media/bg.96ed787e.png";